const table = [
  {
    prop: 'group_name',
    label: 'Nombre',
    minWidth: 150
  },  
  {
    prop: 'lower_weight',
    label: 'Peso Mín.',
    minWidth: 100
  },
  {
    prop: 'upper_weight',
    label: 'Peso Máx.',
    minWidth: 100
  },
  {
    prop: 'crop.name',
    label: 'Cultivo',
    minWidth: 150
  },
  {
    prop: 'zone_label',
    label: 'Zona de abastecimiento',
    minWidth: 170
  },
  {
    prop: 'subzone_label',
    label: 'Zona geográfica',
    minWidth: 150
  },
  {
    prop: 'crop_variety_label',
    label: 'Variedad',
    minWidth: 150
  },
]

export default table
